import { useStore } from '../core/store'

export default function SheetTabs({ onToast }: { onToast: (m: string) => void }) {
  const wb = useStore((s) => s.wb)
  const setActiveSheet = useStore((s) => s.setActiveSheet)
  const addSheet = useStore((s) => s.addSheet)
  const renameSheet = useStore((s) => s.renameSheet)
  const deleteSheet = useStore((s) => s.deleteSheet)

  return (
    <div className="tabs">
      {wb.sheets.map((s) => (
        <button
          key={s.id}
          className={`tab${s.id === wb.activeSheetId ? ' active' : ''}`}
          onClick={() => setActiveSheet(s.id)}
          onDoubleClick={() => {
            const name = prompt('시트 이름', s.name)
            if (!name) return
            try {
              renameSheet(s.id, name)
            } catch (e: any) {
              onToast(e?.message ?? String(e))
            }
          }}
          onContextMenu={(e) => {
            e.preventDefault()
            if (!confirm(`"${s.name}" 시트를 삭제할까요?`)) return
            try {
              deleteSheet(s.id)
            } catch (err: any) {
              onToast(err?.message ?? String(err))
            }
          }}
          title="더블클릭=이름변경 · 우클릭=삭제"
        >
          {s.name}
        </button>
      ))}
      <button className="tab-add" onClick={() => addSheet()} title="시트 추가">
        ＋
      </button>
    </div>
  )
}
